import { ProductType } from "@repo/api";
import { cs } from "@repo/ui";

export function isChangeInvestmentStrategyInProgress(
  allowedChanges: { canChangeInvestmentStrategy?: boolean | null } | undefined,
  allowedChangesLoading: boolean,
  productType: string
): boolean {
  return (
    allowedChanges !== undefined &&
    !allowedChangesLoading &&
    allowedChanges.canChangeInvestmentStrategy === false &&
    productType === ProductType.Uf
  );
}

export function getContractTypeToTitle(type: ProductType): string {
    switch (type) {
        case ProductType.Uf: return cs.contractTypeToTitle.Uf;
        case ProductType.Cl: return cs.contractTypeToTitle.Cl;
        case ProductType.Pf: return cs.contractTypeToTitle.Pf;
        case ProductType.Clf: return cs.contractTypeToTitle.Clf;
        case ProductType.Ds: return cs.contractTypeToTitle.Ds;
        default: console.warn("Unknown contract tittle type: ", type);
                 return "";
    }
}

export function getContractTypeToProductName(type: ProductType): string {
    switch (type) {
        case ProductType.Uf: return cs.contractTypeToProductName.Uf;
        case ProductType.Pf: return cs.contractTypeToProductName.Pf;
        default: console.warn("Unknown product name type: ", type);
                 return "";
    }
}

export function getContractTypeToDescription(type: ProductType): string {
    switch (type) {
        case ProductType.Uf: return cs.contractTypeToDescription.Uf;
        case ProductType.Pf: return cs.contractTypeToDescription.Pf;
        case ProductType.Cl: return cs.contractTypeToDescription.Cl;
        case ProductType.Clf: return cs.contractTypeToDescription.Clf;
        default: console.warn("Unknown contract description type: ", type);
                 return "";
    }
}

export function getContractListHeading(type: ProductType, isChildrenContract?: boolean, childName?: string | null): string {
  const pensionHeading = cs.contractListHeadings.pensionSavings;
  const lifeHeading = cs.contractListHeadings.lifeInsurance;

  if (isChildrenContract && type === ProductType.Uf) {
    return childName ? `${pensionHeading} - ${childName}` : pensionHeading;
  }

  if (type === ProductType.Uf || type === ProductType.Pf) {
    return pensionHeading;
  }

  if (type === ProductType.Cl || type === ProductType.Clf) {
    return lifeHeading;
  }

  return getContractTypeToTitle(type);
}

export function formatContractListSubtitle(productName: string, contractNumber: string): string {
  return `${productName} (${contractNumber})`;
}